import qs from 'qs'

import { api } from '$utils/apiRequester'
import { projectSearchFieldsForGuests, projectSearchFieldsForUsers } from '$utils/extraFields'

const stringifyQualifiers = input => {
  return Object.keys(input)
    .filter(key => input[key] && input[key].length > 0)
    .map(key => {
      if (Array.isArray(input[key])) {
        return input[key].map(value => `${key}:${value}`).join('+')
      } else {
        return `${key}:${input[key]}`
      }
    })
    .join('+')
}

const getQuerySearch = (searchText, qualifiers) => {
  return [searchText, stringifyQualifiers(qualifiers)].filter(value => value && value.length > 0).join('+')
}

const BASE_SEARCH_API = '/search/projects'

export const fetchSearchProjects = (search = '', qualifiers, params = {}, withAccessToken) => {
  const extraFields = withAccessToken ? projectSearchFieldsForUsers : projectSearchFieldsForGuests
  const query = qs.stringify(
    {
      q: getQuerySearch(search, qualifiers),
      extra_fields: extraFields.join(','),
      ...params
    },
    { encode: false }
  )

  const character = query.length > 0 ? '?' : ''
  const endpoint = `${BASE_SEARCH_API}${character}${query}`

  return api('ulule')
    .get(endpoint, {
      withAccessToken
    })
    .catch(error => {
      throw error
    })
}

export const fetchSearchMoreProjects = (next, withAccessToken) => {
  const endpoint = `${BASE_SEARCH_API}${next}`

  return api('ulule')
    .get(endpoint, {
      withAccessToken
    })
    .catch(error => {
      throw error
    })
}
